/* One native disclosure owner; interruptible, height-only motion keeps text sharp. */
(() => {
 'use strict';
 const reduce=matchMedia('(prefers-reduced-motion: reduce)'),motions=new WeakMap();
 window.mkProductAccordionMotion=(event,details,summary,content)=>{
  event.preventDefault();
  let state=motions.get(details);
  if(!state){state={expanded:details.open,animation:null};motions.set(details,state);}
  if(!state.animation)state.expanded=details.open;
  const start=details.getBoundingClientRect().height;
  state.animation?.cancel();state.animation=null;
  state.expanded=!state.expanded;
  details.open=true;
  details.style.height='auto';details.style.overflow='hidden';
  content.style.opacity='1';content.style.transform='none';content.inert=!state.expanded;
  summary.setAttribute('aria-expanded',String(state.expanded));
  if(!state.expanded&&content.contains(document.activeElement))summary.focus({preventScroll:true});
  const border=parseFloat(getComputedStyle(details).borderTopWidth)+parseFloat(getComputedStyle(details).borderBottomWidth);
  const end=state.expanded?details.scrollHeight+border:summary.getBoundingClientRect().height+border;
  const finish=()=>{details.open=state.expanded;details.style.removeProperty('height');details.style.removeProperty('overflow');state.animation=null;};
  if(reduce.matches||Math.abs(end-start)<1){finish();return;}
  const budget=state.expanded?240:180;
  const base=Math.min(budget,parseFloat(getComputedStyle(details).getPropertyValue(state.expanded?'--mk-open-ms':'--mk-close-ms'))||budget);
  const duration=Math.round(Math.max(70,base*Math.min(1,Math.abs(end-start)/Math.max(end,start,1))));
  const animation=details.animate([{height:start+'px'},{height:end+'px'}],{duration,easing:'cubic-bezier(.22,.72,.22,1)',fill:'backwards'});
  animation.startTime=performance.now();
  state.animation=animation;animation.onfinish=()=>{if(state.animation===animation)finish();};
 };
 const initialize=(scope=document)=>{
  const root=scope.matches?.('[data-monster-product]')?scope:scope.querySelector('[data-monster-product]');if(!root||root.dataset.brandReady)return;root.dataset.brandReady='true';
  const picker=root.querySelector('hdt-variant-picker'),abort=new AbortController(),signal=abort.signal;
  let frame=0,pendingVariant=null;
  const update=variant=>{
   const selected=variant?.options||Array.from(picker?.querySelectorAll('input[is-value]')||[]).map(input=>input.value);
   const color=selected.find(value=>/^(pink|red|lavender|teal|white|black|green)$/i.test(value));
   if(color){const value=color.charAt(0).toUpperCase()+color.slice(1).toLowerCase();if(document.body.dataset.mkColor!==value)document.body.dataset.mkColor=value;}
  };
  const schedule=event=>{
   if(event?.type==='variant:change'&&!root.contains(event.target))return;
   if(event?.detail?.variant)pendingVariant=event.detail.variant;
   if(!frame)frame=requestAnimationFrame(()=>{frame=0;const variant=pendingVariant;pendingVariant=null;if(!signal.aborted&&root.isConnected)update(variant);});
  };
  document.addEventListener('variant:change',schedule,{signal});
  root.addEventListener('change',schedule,{signal});
  document.addEventListener('shopify:section:unload',event=>{if(!event.target.contains(root))return;cancelAnimationFrame(frame);abort.abort();delete root.dataset.brandReady;},{signal});
  update();
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});else initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
